<template>
  <div class="row">
    <div class="col-lg-12">
      <card>
        <div v-if="!loggedUser.active" class="card-body">
          <h3 class="cart-title">{{$t('dashboard.complete_account')}}</h3>
          <div class="row">
            <div class="col-lg-6">
              <base-alert type="warning" v-if="!loggedUser.emailVerifiedAt">
                {{$t('dashboard.email_not_verified')}}
                <div v-if="!resentConfirmationEmail">
                  <button @click="resendConfirmationEmail" class="mt-4 btn text-white border-white btn-simple">{{$t('dashboard.click_to_resend')}}</button>
                </div>
              </base-alert>
              <base-alert type="success" v-else>
                {{$t('dashboard.email_verified')}}
              </base-alert>
              <base-alert type="warning" v-if="!loggedUser.name">
                {{$t('dashboard.registration_not_complete')}}
                <p>
                  <router-link class="text-white" to="/user/profile">
                    <button class="mt-4 btn text-white border-white btn-simple">{{$t('dashboard.click_to_complete')}}</button>
                  </router-link>
                </p>
              </base-alert>
            </div>
          </div>
        </div>

      </card>
    </div>
  </div>
</template>
<script>
  import {BaseAlert} from 'src/components';
  import {AuthService} from "@/services";

  export default {
    components: {
      BaseAlert
    },
    data() {
      return {
        resentConfirmationEmail: false
      }
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      }
    },
    methods: {
      async resendConfirmationEmail() {
        let loader = this.$loading.show();

        let success = false;
        await AuthService.resendConfirmEmail().then((res) => {
          success = true;
        }).catch((error) => {
          alert('Could not resend email, please try again later.');
        });

        if (success) {
          let email = this.$store.getters['Auth/loggedUser'].email;

          this.resentConfirmationEmail = true;

          this.$notify({
            message: this.$t('dashboard.email_confirmation_resent_success', [email]).split("\n").join("<br>"),
            timeout: 5000,
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'info'
          });
        }

        loader.hide();
      }
    }
  }
</script>
<style lang="scss">
  .white-content .font-icon-detail i {
    color: $gray-500;
  }

  .application-button {
    cursor: pointer;

    &.font-icon-detail {
      border: none;
    }

    i {
      font-size: 5rem;
    }

    h4 {
      margin-top: 2rem;
    }
  }
</style>
